import { render, staticRenderFns } from "./JoinYourTeam.vue?vue&type=template&id=21e7bbe4&"
import script from "./JoinYourTeam.vue?vue&type=script&lang=js&"
export * from "./JoinYourTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports